(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[128],{

/***/ 88546:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/setting/info/terms/[file]",
      function () {
        return __webpack_require__(19943);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ DecoratedButton; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n              background: ",
        ";\n              color: ",
        ";\n            "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n              background: ",
        ";\n              color: ",
        ";\n\n              &:active {\n                background-image: linear-gradient(rgb(0, 0, 0, 0.1) 0 0);\n              }\n            "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n        height: 48px;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n\n        ",
        "\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n              border-color: ",
        ";\n              color: ",
        ";\n            "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n              border-color: ",
        ";\n              color: ",
        ";\n\n              &:active {\n                background-image: linear-gradient(rgb(0, 0, 0, 0.1) 0 0);\n              }\n            "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n        height: 48px;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n        border-width: 1px;\n        border-style: solid;\n        border-radius: ",
        "px;\n        background-color: ",
        ";\n\n        ",
        ";\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n        height: 24px;\n        color: ",
        ";\n      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      width: 100%;\n      border-radius: ",
        "px;\n      font-size: ",
        "px;\n      font-weight: 600;\n\n      ",
        "\n\n      ",
        "\n\n      ",
        "\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var buttonCSS = function(type, color, backgroundColor) {
    var isDisabled = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject7(), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Radius.medium */ .wU.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .FontSizes.small */ .TS.small, type === "fill" && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject2(), isDisabled ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject(), theme.var.gray200, theme.var.gray400) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject1(), backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.colors.main500, color !== null && color !== void 0 ? color : theme.true.white)), type === "border" && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject5(), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Radius.medium */ .wU.medium, theme.var.white, isDisabled ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject3(), theme.var.gray200, theme.var.gray400) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject4(), backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.colors.main500, backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.colors.main500)), type === "text" && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject6(), color !== null && color !== void 0 ? color : theme.var.gray500));
    };
};
var Button = function(param) {
    var className = param.className, _type = param.type, type = _type === void 0 ? "fill" : _type, htmlType = param.htmlType, text = param.text, color = param.color, backgroundColor = param.backgroundColor, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, children = param.children, onClick = param.onClick;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
        className: className,
        type: htmlType,
        css: buttonCSS(type, color, backgroundColor, disabled),
        disabled: disabled,
        onClick: onClick,
        children: children || text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);
var DecoratedButton = function(_param) {
    var className = _param.className, decoration = _param.decoration, color = _param.color, backgroundColor = _param.backgroundColor, children = _param.children, props = _objectWithoutProperties(_param, [
        "className",
        "decoration",
        "color",
        "backgroundColor",
        "children"
    ]);
    var ref, ref1;
    var ref2;
    var _color = (ref2 = decoration === null || decoration === void 0 ? void 0 : (ref = decoration.object) === null || ref === void 0 ? void 0 : ref.textColor) !== null && ref2 !== void 0 ? ref2 : color;
    var ref3;
    var _backgroundColor = (ref3 = decoration === null || decoration === void 0 ? void 0 : (ref1 = decoration.object) === null || ref1 === void 0 ? void 0 : ref1.backgroundColor) !== null && ref3 !== void 0 ? ref3 : backgroundColor;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Button, _objectSpreadProps(_objectSpread({
        className: className
    }, props), {
        color: _color,
        backgroundColor: _backgroundColor,
        children: children
    }));
};


/***/ }),

/***/ 38632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ OverlayClose; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71618);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7685);
/* harmony import */ var _hooks_useDelayedState__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46726);
/* harmony import */ var _hooks_useMounted__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38464);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82740);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96964);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n        visibility: visible;\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n        visibility: hidden;\n        transition: visibility 0s 0.4s;\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    pointer-events: none;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  ",
        ";\n  width: 100%;\n  height: 100%;\n  z-index: ",
        ";\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n          opacity: 1;\n        "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n          opacity: 0;\n        "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    ",
        ";\n    height: 100%;\n    background-color: ",
        ";\n    ",
        "\n    transition: opacity 0.3s;\n\n    ",
        "\n    ",
        "\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        "px;\n  right: ",
        "px;\n  z-index: 9;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}










/** Store */ /** Component */ var overlayCSS = function(open, delayOpen) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject3(), _styles_css__WEBPACK_IMPORTED_MODULE_7__/* .responsiveMaxWidth */ .S8, 99 + depth, open ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject()) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject1()), !delayOpen && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject2()));
};
var bgCSS = function(isOpen) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject6(), _styles_css__WEBPACK_IMPORTED_MODULE_7__/* .responsiveMaxWidth */ .S8, theme.overlay.dark, isOpen ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject4()) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject5()), (0,_styles_css__WEBPACK_IMPORTED_MODULE_7__/* .safeArea */ .BI)("top"), (0,_styles_css__WEBPACK_IMPORTED_MODULE_7__/* .safeArea */ .BI)("bottom"));
    };
};
var Overlay = function(param) {
    var className = param.className, open = param.open, name = param.name, depth = param.depth, _blocking = param.blocking, blocking = _blocking === void 0 ? true : _blocking, onClose = param.onClose, onClosePageClick = param.onClosePageClick, children = param.children;
    var isMounted = (0,_hooks_useMounted__WEBPACK_IMPORTED_MODULE_4__/* .useMounted */ .s)();
    var ref = _slicedToArray((0,_hooks_useDelayedState__WEBPACK_IMPORTED_MODULE_3__/* .useDelayedState */ .F)(open), 3), delayOpen = ref[0], setDelayOpenImmediate = ref[1], setDelayOpen = ref[2];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (open) {
            setDelayOpen(true);
        } else {
            setDelayOpenImmediate(false);
        }
    }, [
        open
    ]);
    return isMounted ? /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)(/*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        id: name,
        css: overlayCSS(open, delayOpen, depth),
        className: className,
        onClick: function() {
            return onClosePageClick && onClosePageClick();
        },
        ref: ref1,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                css: bgCSS(open),
                onClick: blocking ? function() {
                    return onClose();
                } : undefined
            }),
            children
        ]
    }), document.getElementById("overlay")) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Overlay);
var overlayCloseCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject7(), chatie_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Spacing.xsmall */ .Ki.xsmall);
var OverlayClose = function(param) {
    var onClose = param.onClose;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__.u)();
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("button", {
        css: overlayCloseCSS,
        className: "icon-btn",
        "aria-label": t("닫기"),
        onClick: function() {
            return onClose();
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
            icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_6__/* .Close */ .x8,
            color: theme.var.black
        })
    });
};


/***/ }),

/***/ 26382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11717);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83289);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var _stores_useThemeStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34946);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39819);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30259);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96964);
/* harmony import */ var _Push__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23516);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    max-width: ",
        "px;\n    margin: 0 auto;\n    background-color: ",
        ";\n    min-height: 100%;\n\n    color: ",
        ";\n\n    ",
        " {\n      max-width: ",
        "px;\n    }\n\n    ",
        " {\n      max-width: ",
        "px;\n    }\n\n    @media all and (min-width: ",
        "px) {\n      box-shadow: 0 0 10px ",
        "cc;\n    }\n\n    .has-sidebar & {\n      ",
        " {\n        max-width: none;\n        margin: 0;\n        box-shadow: none;\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  min-height: 100%;\n\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n                @media all and (min-width: ",
        "px) {\n                  html {\n                    background-color: ",
        ";\n                  }\n                }\n              "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n                html {\n                  background-color: ",
        " !important;\n                }\n              "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var pcLayoutCSS = function(backgroundColor) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject(), _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .MAX_WIDTH */ .d, backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.var.white, theme.var.black, _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .media.tablet */ .BC.tablet, _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .BREAKPOINTS.tablet */ .j$.tablet, _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .media.desktop */ .BC.desktop, _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .BREAKPOINTS.desktop */ .j$.desktop, _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .BREAKPOINTS.desktop */ .j$.desktop + 1, theme.var.gray200, _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .media.tablet */ .BC.tablet);
    };
};
var mobileLayoutCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject1(), theme.var.black);
};
var Layout = function(param) {
    var className = param.className, theme = param.theme, backgroundColor = param.backgroundColor, children = param.children, isSSR = param.isSSR, isPush = param.isPush;
    var platform = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_4__/* .useGlobalContext */ .bN)().platform;
    var setTheme = (0,_stores_useThemeStore__WEBPACK_IMPORTED_MODULE_2__/* .useThemeStore */ .f)().setTheme;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isSSR) {
            return;
        }
        // theme prop이 명시적으로 전달된 경우에만 override
        if (theme) {
            setTheme(theme);
        } else {
            // localStorage에 저장된 테마가 없을 때만 __darkMode__ 사용
            var stored = localStorage.getItem("theme");
            if (!stored) {
                setTheme(window.__darkMode__ ? "dark" : "light");
            }
        }
    }, [
        theme,
        isSSR
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
        className: className,
        suppressHydrationWarning: true,
        css: platform === _constants__WEBPACK_IMPORTED_MODULE_3__/* .Platform.web */ .t4.web ? pcLayoutCSS(backgroundColor) : mobileLayoutCSS,
        children: [
            backgroundColor && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("meta", {
                    name: "theme-color",
                    content: backgroundColor
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_emotion_react__WEBPACK_IMPORTED_MODULE_7__.Global, {
                styles: function(theme) {
                    return platform === _constants__WEBPACK_IMPORTED_MODULE_3__/* .Platform.web */ .t4.web ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject2(), _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .BREAKPOINTS.desktop */ .j$.desktop + 1, theme.var.gray100) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject3(), backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.var.white);
                }
            }),
            children,
            isPush && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_Push__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                size: _Push__WEBPACK_IMPORTED_MODULE_6__/* .PushSize.bottomTab */ .z.bottomTab,
                bottom: true
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 23516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ PushSize; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9150);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96964);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  box-sizing: content-box;\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var pushCSS = function(isTopSafeArea, isBottomSafeArea) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject(), isTopSafeArea && (0,_styles_css__WEBPACK_IMPORTED_MODULE_2__/* .safeArea */ .BI)("top"), isBottomSafeArea && (0,_styles_css__WEBPACK_IMPORTED_MODULE_2__/* .safeArea */ .BI)("bottom", "padding", chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium));
};
var Push = function(param, ref) {
    var _top = param.top, top = _top === void 0 ? false : _top, _bottom = param.bottom, bottom = _bottom === void 0 ? false : _bottom, size = param.size;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        ref: ref,
        css: pushCSS(top, bottom),
        style: {
            height: size
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Push));
var PushSize;
(function(PushSize) {
    PushSize[PushSize["safe"] = 0] = "safe";
    PushSize[PushSize["header"] = 44] = "header";
    PushSize[PushSize["bottomButton"] = 64] = "bottomButton";
    PushSize[PushSize["bottomTab"] = 56] = "bottomTab";
    PushSize[PushSize["commentForm"] = 70] = "commentForm";
    PushSize[PushSize["tab"] = 43] = "tab";
    PushSize[PushSize["floatingButton"] = 72] = "floatingButton";
})(PushSize || (PushSize = {}));


/***/ }),

/***/ 46726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useDelayedState; },
/* harmony export */   "N": function() { return /* binding */ useDelayedFlag; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);

var useDelayedState = function(initialValue) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialValue), value = ref[0], setValue = ref[1];
    var timeout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    var setDelayValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(value) {
        timeout.current = window.setTimeout(function() {
            setValue(value);
        }, delay);
    }, [
        delay
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return function() {
            clearTimeout(timeout.current);
        };
    }, []);
    return [
        value,
        setValue,
        setDelayValue
    ];
};
var useDelayedFlag = function(enabled) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), value = ref[0], setValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!enabled) {
            setValue(false);
            return;
        }
        var timeout = window.setTimeout(function() {
            setValue(true);
        }, delay);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        delay,
        enabled
    ]);
    return value;
};


/***/ }),

/***/ 38464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useMounted; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);

var useMounted = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setMounted(true);
    }, []);
    return mounted;
};


/***/ }),

/***/ 19943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11717);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9150);
/* harmony import */ var _components_layout_Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58761);
/* harmony import */ var _components_layout_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26382);
/* harmony import */ var _contexts_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31779);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  gap: ",
        "px;\n  padding: ",
        "px ",
        "px;\n  color: ",
        ";\n\n  h2 {\n    margin-top: ",
        "px;\n    margin-bottom: ",
        "px;\n  }\n\n  h3 {\n    margin: 32px 0 ",
        "px;\n  }\n\n  div {\n    padding-left: ",
        "px;\n  }\n\n  p {\n    margin-bottom: ",
        "px;\n  }\n\n  strong {\n    display: block;\n    margin-bottom: ",
        "px;\n  }\n\n  p + ul {\n    margin-left: 36px;\n  }\n\n  ul {\n    list-style-position: outside;\n    margin-left: ",
        "px;\n  }\n\n  ul,\n  ol,\n  li {\n    list-style: inherit;\n    margin-bottom: ",
        "px;\n  }\n\n  ol {\n    list-style-position: outside;\n    list-style-type: decimal;\n    margin-left: ",
        "px;\n  }\n\n  li + li {\n    margin-top: ",
        "px;\n  }\n\n  li ul,\n  li ol {\n    margin-top: ",
        "px;\n    margin-bottom: 0;\n  }\n\n  li ul {\n    list-style-type: circle;\n  }\n\n  li ol {\n    list-style-type: decimal;\n  }\n\n  a {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n\n  table {\n    margin: ",
        "px 0 ",
        "px;\n  }\n\n  table,\n  table th,\n  table td {\n    border: 1px solid black;\n    border-collapse: collapse;\n    padding: ",
        "px;\n  }\n\n  table td {\n    vertical-align: middle;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var containerCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.large */ .Ki.large, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.large */ .Ki.large, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium, theme.var.black, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xlarge */ .Ki.xlarge, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xlarge */ .Ki.xlarge, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.small */ .Ki.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.large */ .Ki.large, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.large */ .Ki.large, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xxsmall */ .Ki.xxsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xxsmall */ .Ki.xxsmall, theme.colors.main300, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xxlarge */ .Ki.xxlarge, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xsmall */ .Ki.xsmall);
};
var TERM_TITLES = {
    terms: "서비스 이용 약관",
    privacy: "개인정보 처리방침"
};
var TermsPage = function(param) {
    var termsOfServiceHTML = param.termsOfServiceHTML, fileName = param.fileName;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_components_layout_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_layout_Header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: t(TERM_TITLES[fileName])
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                css: containerCSS,
                dangerouslySetInnerHTML: {
                    __html: termsOfServiceHTML
                }
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,_contexts_auth__WEBPACK_IMPORTED_MODULE_4__/* .withAuth */ .QO)(TermsPage, {
    isSignInRequired: false
}));


/***/ }),

/***/ 74001:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/InView.tsx


// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
function getRootId(root) {
  if (!root)
    return "0";
  if (RootIds.has(root))
    return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  let id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  let callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip)
      return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};

// src/useInView.tsx

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(
    () => {
      if (skip || !ref)
        return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current)
            callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

//# sourceMappingURL=index.mjs.map

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9150,8761,9774,2888,179], function() { return __webpack_exec__(88546); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);